<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-expand-all</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">カテゴリ情報登録</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="category_form" v-model="valid" @submit.prevent>
              <v-text-field label="カテゴリ名" v-model="name" :rules="categoryNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'CategoryMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
        <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleStore
          @stored="submit" @canceled="dialogCancel"/>
      </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import CategoryApi from "@/api/category-api";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import Rule from "@/validation/rules";

export default {
  name: "CategoryMasterEntry",
  components: {
    CustomDialog
  },
  data: () => ({
    loading: false,
    //フォームの項目
    name: "",

    // 登録ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,

    // バリデーション
    valid: true,
    categoryNameRules: Rule.categoryNameRules
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.categoryApi = new CategoryApi();
    },
    //登録ボタン押下時
    checkDialog() {
      this.dialogTitle = "登録しますか？";
      this.dialogItems = [
        { name: "カテゴリ名", value: this.name }
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    //ダイアログ登録ボタン押下時
    submit() {
      if (this.$refs.category_form.validate()) {
        this.isLoading();
        const params = {
          name: this.name
        };
        const promise = this.categoryApi.store(params);
        promise.then(response => {
          this.$router.push({ name: 'CategoryMaster' });
          this.$emit("success", response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  }
};
</script>
